export default __webpack_public_path__ + "static/media/JosefinSans.89302acc.ttf";